import React from "react";
import moment from "moment";

import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import Form from "react-bootstrap/Form";
import { APPLICATION_CONFIGURATIONS } from "../../Utils/ApplicationConfigurations";

import "./Calender.scss";
import { DATE_FORMAT } from "../../Utils/Constants";

class Calender extends React.Component {
  state = {
    open: false,
    today: new moment(),
    yesterday: new moment().subtract(1, "day"),
  };
  renderInput = (calenderProps, openCalendar, closeCalendar) => {
    let iconClick = () => {
      this.setState({ open: !this.refc.state.open }, () =>
        this.state.open ? openCalendar() : closeCalendar()
      );
    };
    let value = this.props.value;
    if (this.props.value && !this.props.jobDates && this.props.dateFormat !== "MM-YYYY") {
      value = new moment(value).format(DATE_FORMAT);
    } else if (this.props.dateFormat === "MM-YYYY") {
      value = this.props.value
    }
    else if (!this.props.jobDates) {
      value = "";
    }
    return (
      <div>
        <Form.Control
          className={this.props.className}
          placeholder={this.props.placeholder}
          disabled={true}
          value={value}
          name={this.props.name}
        />
        <i
          disabled={this.props.disabled}
          className={
            this.props.disabled
              ? "fa fa-calendar fa-lg textFieldCalendar disableCursor"
              : "fa fa-calendar fa-lg textFieldCalendar calender"
          }
          onClick={
            this.props.disabled
              ? () => {
                //This is intensional
              }
              : iconClick
          }
        />
      </div>
    );
  };

  //Disable future date or past date
  valid = (selectedDate) => {
    selectedDate = new moment(selectedDate);
    let returnVal = false;
    if (selectedDate) {
      if (this.props.isBefore)
        returnVal = !selectedDate.isBefore(this.state.yesterday);
      else if (this.props.isAfter)
        returnVal = !selectedDate.isAfter(this.state.today);
      else returnVal = selectedDate;
    }
    return returnVal;
  };

  render() {
    return (
      <div>
        <Datetime
          ref={(ref) => (this.refc = ref)}
          renderInput={this.renderInput}
          dateFormat={this.props?.dateFormat ?? true}
          value={this.props.value}
          closeOnSelect={true}
          locale={APPLICATION_CONFIGURATIONS.applicationLanguage}
          onChange={this.props.handleChange}
          isValidDate={this.valid}
          viewMode={this.props?.viewMode ?? "days"}
          input={true}
          timeFormat={false}
        />
      </div>
    );
  }
}

export default Calender;
